import { parseBoolean } from '../../../../core/util/boolean-parser.util';

export type FormBoolean = 'yes' | 'no';

export class ProjectModuleForm {
  // The schemaID is only needed when creating a new module
  schemaID?: string;
  status?: string;
  occupantRules?: string;
  teamMemberRules?: string;
  externalDeliveryContainerRules?: string;
  internalDeliveryContainerRules?: string;
  providerId?: string;
  carrierCode?: string;
  // Click & Collect specific fields
  deactivateUsersAfterDays?: number | null;
  deliveredToRequirement?: string | null;
  // Dry Cleaning specific fields
  isQrDeliveryOnly?: FormBoolean;
  appName?: string;
  appInstallationUrl?: string;

  static GetInitialData(settings?: Record<string, any>, form?: ProjectModuleForm): ProjectModuleForm {
    return {
      schemaID: form?.schemaID || settings?.schemaID,
      status: form?.status || settings?.status,
      occupantRules: form?.occupantRules || settings?.occupantRules,
      teamMemberRules: form?.teamMemberRules || settings?.teamMemberRules,
      externalDeliveryContainerRules: form?.externalDeliveryContainerRules || settings?.externalDeliveryContainerRules,
      internalDeliveryContainerRules: form?.internalDeliveryContainerRules || settings?.internalDeliveryContainerRules,
      providerId: form?.providerId || settings?.providerId,
      carrierCode: form?.carrierCode || settings?.carrierCode,
      // Click & Collect specific fields
      // Not `||`: null is a real value here (it switches the setting off), and leaving the key
      // undefined when the module has never carried one keeps the settings PUT faithful.
      deactivateUsersAfterDays:
        form?.deactivateUsersAfterDays !== undefined
          ? form.deactivateUsersAfterDays
          : settings?.deactivateUsersAfterDays,
      // Same as above: an unset value stays unset (meaning at-booking) unless the user picks one.
      deliveredToRequirement:
        form?.deliveredToRequirement !== undefined ? form.deliveredToRequirement : settings?.deliveredToRequirement,
      // Dry Cleaning specific fields
      isQrDeliveryOnly: form?.isQrDeliveryOnly || parseBoolean(settings?.isQrDeliveryOnly) ? 'yes' : 'no',
      appName: (form?.appName || settings?.appName) ?? '',
      appInstallationUrl: (form?.appInstallationUrl || settings?.appInstallationUrl) ?? ''
    };
  }
}
